<app-header></app-header>
<div class="row dashboard justify-content-center mx-0" *ngIf="!loading && (dashboardMidwife || dashboardMum)">
    <div class="col-11 col-sm-10 mb-3">
        <div class="row my-2" *ngIf="authService.user?.userType==userType.MIDWIFE && dashboardMidwife.payload
        && (width < 991 || width > 1200)">
            <div class="col-lg-6 col-xl-3">
                <div class="d-flex flex-column">
                    <app-profile-info class="my-2" [dashboard]="dashboardMidwife.payload"></app-profile-info>
                    <app-chats class="my-2"></app-chats>
                </div>
            </div>
            <div class="col-lg-6 col-xl-9">
                <div class="row">
                    <div class="col-xl-8 my-2">
                        <app-my-calendar [dashboard]="dashboardMidwife.payload"></app-my-calendar>
                    </div>
                    <div class="col-xl-4 my-2">
                        <app-appointment-requests [dashboard]="dashboardMidwife.payload">
                        </app-appointment-requests>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-7">
                        <div class="d-flex flex-column">
                            <app-my-notes class="my-2" [dashboard]="dashboardMidwife.payload"></app-my-notes>
                            <app-my-blogs class="my-2" [dashboard]="dashboardMidwife.payload"></app-my-blogs>
                        </div>
                    </div>
                    <div class="col-xl-5">
                        <div class="d-flex flex-column">
                            <app-notifications class="my-2"></app-notifications>
                            <app-signed-up-clients class="my-2" [dashboard]="dashboardMidwife.payload">
                            </app-signed-up-clients>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2" *ngIf="authService.user?.userType==userType.MIDWIFE && dashboardMidwife.payload
        && (width > 991 && width < 1200)">
            <div class="col-lg-6">
                <div class="d-flex flex-column">
                    <app-profile-info class="my-2" [dashboard]="dashboardMidwife.payload"></app-profile-info>
                    <app-chats class="my-2"></app-chats>
                    <app-my-notes class="my-2" [dashboard]="dashboardMidwife.payload"></app-my-notes>
                    <app-my-blogs class="my-2" [dashboard]="dashboardMidwife.payload"></app-my-blogs>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="d-flex flex-column">
                    <app-my-calendar class="my-2" [dashboard]="dashboardMidwife.payload"></app-my-calendar>
                    <app-appointment-requests class="my-2" [dashboard]="dashboardMidwife.payload">
                    </app-appointment-requests>
                    <app-notifications class="my-2"></app-notifications>
                    <app-signed-up-clients class="my-2" [dashboard]="dashboardMidwife.payload">
                    </app-signed-up-clients>
                </div>
            </div>
        </div>
        <div class="row mt-2" *ngIf="authService.user?.userType==userType.MUM && dashboardMum.payload && (width > 991 && width < 1200)">
            <div class="col-6">
                <div class="d-flex flex-column">
                    <app-profile-info class="my-2" [dashboard]="dashboardMum.payload">
                    </app-profile-info>
                    <app-notification-mom class="my-2"></app-notification-mom>
                    <app-tips-for-pregnancy class="my-2" [dashboard]="dashboardMum.payload">
                    </app-tips-for-pregnancy>
                </div>
            </div>
            <div class="col-6">
                <div class="d-flex flex-column">
                    <app-chats class="my-2"></app-chats>
                    <app-booked-midwifes class="my-2" [dashboard]="dashboardMum.payload"></app-booked-midwifes>
                    <button class="btn btn-lg btn-theme w-100 my-3" [routerLink]="['/search-listing']">Find a
                        Midwife</button>
                    <app-blogs-and-articles class="my-2" [dashboard]="dashboardMum.payload"></app-blogs-and-articles>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="authService.user?.userType==userType.MUM && dashboardMum.payload && (width < 991 || width > 1200)">
            <div class="col-12 mt-2">
                <div class="row">
                    <div class="col-lg-6 col-xl-3 my-2">
                        <app-profile-info class="my-2" [dashboard]="dashboardMum.payload">
                        </app-profile-info>
                    </div>
                    <div class="col-lg-6 col-xl-5 d-flex flex-column my-2">
                        <app-blogs-and-articles [dashboard]="dashboardMum.payload">
                        </app-blogs-and-articles>
                    </div>
                    <div class="col-lg-6 col-xl-4 my-2">
                        <app-chats class="my-2"></app-chats>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-6 col-xl-3 my-2">
                        <button class="btn btn-lg btn-theme w-100 mb-3 mt-1" [routerLink]="['/search-listing']">Find a
                            Midwife</button>
                        <app-booked-midwifes class="mb-2" [dashboard]="dashboardMum.payload"></app-booked-midwifes>
                    </div>
                    <div class="col-lg-6 col-xl-5 my-2">
                        <app-notification-mom class="my-2"></app-notification-mom>
                    </div>
                    <div class="col-lg-6 col-xl-4 my-2">
                        <app-tips-for-pregnancy class="my-2" [dashboard]="dashboardMum.payload">
                        </app-tips-for-pregnancy>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row my-5" *ngIf="loading">
    <div class="spinner-border loader" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<app-footer></app-footer>

<!-- Booking Request Modal Starts -->
<app-appointment-modal></app-appointment-modal>
<!-- Booking Request Modal Ends -->
